import { Translations } from '../types/localization.types';

/**
 * Turkish translations for PDF Form Designer
 */
export const tr: Translations = {
  elements: {
    textInput: 'Metin Girişi',
    radioButton: 'Radyo Düğmesi',
    checkbox: 'Onay Kutusu',
    signature: 'E-İmza',
    digitalSignature: 'Dijital İmza',
    biometricSignature: 'Biyometrik İmza',
    initials: 'Paraf',
    text: 'Metin',
    attachmentsList: 'Ek Listesi'
  },

  buttons: {
    save: 'Değişiklikleri Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    deleteAll: 'Tüm Parafları Sil',
    addToOtherPages: 'Diğer Sayfalara Ekle',
    clearAll: 'Tümünü Temizle',
    edit: 'Düzenle'
  },

  modal: {
    editElement: '{type} Öğesini Düzenle',
    properties: 'Özellikler'
  },

  fields: {
    name: 'İsim',
    readOnly: 'Salt Okunur',
    required: 'Zorunlu',
    placeholder: 'Yer Tutucu',
    defaultValue: 'Varsayılan Değer',
    fontSize: 'Yazı Boyutu',
    fontFamily: 'Yazı Tipi',
    fontWeight: 'Yazı Kalınlığı',
    textColor: 'Metin Rengi',
    backgroundColor: 'Arka Plan Rengi',
    borderColor: 'Kenarlık Rengi',
    borderWidth: 'Kenarlık Genişliği',
    groupName: 'Grup Adı',
    value: 'Değer',
    selectedValue: 'Seçili Değer',
    label: 'Etiket',
    checked: 'İşaretli',
    buttonColor: 'Düğme Rengi',
    checkColor: 'İşaret Rengi',
    text: 'Metin',
    textAlign: 'Metin Hizalama',
    angle: 'Açı (derece)',
    italic: 'İtalik',
    underline: 'Altı Çizili',
    bold: 'Kalın',
    normal: 'Normal',
    lighter: 'İnce',
    left: 'Sol',
    center: 'Orta',
    right: 'Sağ',
    signatureMethod: 'İmza Yöntemi',
    certificateInfo: 'Sertifika Bilgisi',
    timestampRequired: 'Zaman Damgası Gerekli',
    deviceInfo: 'Cihaz Bilgisi',
    pressureSensitive: 'Basınç Duyarlı',
    velocityTracking: 'Hız Takibi',
    distanceFromRight: 'Sağ Taraftan Mesafe (PDF noktası)',
    distanceFromBottom: 'Alt Taraftan Mesafe (PDF noktası)',
    // Attachments list specific fields
    listDisplay: 'Liste Görünümü',
    showFileNames: 'Dosya Adlarını Göster',
    showFileSizes: 'Dosya Boyutlarını Göster',
    listStyle: 'Liste Stili',
    listStyleNone: 'Yok (Düz)',
    listStyleNumbers: 'Sayılar (1, 2, 3)',
    textFormatting: 'Metin Biçimlendirme',
    spacingLayout: 'Boşluk ve Düzen',
    lineHeight: 'Satır Yüksekliği',
    lineHeightHelp: 'Boşluk çarpanı (1.0 = sıkı, 2.0 = çift aralıklı)',
    indentation: 'Girinti (nokta)',
    indentationHelp: 'Her ek satırı için sol girinti',
    styling: 'Görsel Stil'
  },

  signatureMethods: {
    pki: 'PKI Sertifikası',
    adobe: 'Adobe Sign',
    docusign: 'DocuSign'
  },

  signers: {
    title: 'İmza Sahipleri',
    noSigners: 'Henüz imza sahibi eklenmedi.',
    addSignersMessage: 'Form öğelerini etkinleştirmek için dışarıdan imza sahipleri ekleyin.',
    activeIndicator: 'Aktif',
    clickToActivate: 'Etkinleştirmek için tıklayın'
  },

  tooltips: {
    disabled: '(Devre Dışı)',
    deleteElement: 'Öğeyi sil',
    editElement: 'Öğe özelliklerini düzenle',
    placeElement: 'Öğeyi yerleştirmek için PDF\'ye tıklayın',
    fontSize: 'Yazı Boyutu',
    fontFamily: 'Yazı Tipi',
    textColor: 'Metin Rengi',
    italic: 'İtalik',
    underline: 'Altı Çizili'
  },

  dialogs: {
    switchSignerConfirm: 'Bu öğe {name} ({email}) kullanıcısına ait. Bu imza sahibine geçmek istiyor musunuz?'
  },

  placeholders: {
    enterText: 'Metin girin...',
    certificateDetails: 'Sertifika detayları',
    deviceInfo: 'Yakalama cihazı bilgisi',
    abc: 'ABC',
    textInput: 'Metin Girişi',
    signature: 'İmza',
    digitalSignature: 'Dijital İmza',
    text: 'Metin',
    attachmentsList: 'Ek Listesi',
    attachmentsCapacity: '({count} ek sığabilir)'
  },

  fonts: {
    arial: 'Arial',
    timesNewRoman: 'Times New Roman',
    helvetica: 'Helvetica',
    courier: 'Courier'
  },

  errors: {
    elementNameEmpty: 'Öğe adı boş olamaz',
    elementNameDuplicate: '"{name}" öğe adı başka bir öğe tarafından kullanılıyor. Adlar global olarak benzersiz olmalıdır.',
    selectedValueEmpty: 'Seçili değer boş olamaz',
    selectedValueDuplicate: '"{value}" seçenek değeri "{group}" grubunda zaten mevcut',
    radioGroupNameConflict: '"{name}" radyo grup adı başka bir imza sahibi tarafından kullanılıyor. Her imza sahibinin benzersiz grup adları olmalıdır.',
    invalidConfigVersion: 'Geçersiz yapılandırma: Yalnızca sürüm 3.0.0 desteklenmektedir. Yapılandırmanızın sayfa boyutlarıyla birlikte kesin koordinatlar kullandığından emin olun.',
    noSignersInConfig: 'Geçersiz yapılandırma: İmza sahibi bulunamadı. Tüm yapılandırmalar en az bir imza sahibi içermelidir.',
    noActiveSignerInConfig: 'Geçersiz yapılandırma: Aktif imza sahibi belirtilmemiş.',
    activeSignerNotInList: 'Geçersiz yapılandırma: Aktif imza sahibi kimliği imza sahipleri listesinde mevcut değil.',
    elementsWithoutSigner: 'Geçersiz yapılandırma: {count} öğe imza sahibi ataması olmadan bulundu.',
    elementsReferenceInvalidSigners: 'Geçersiz yapılandırma: {count} öğe mevcut olmayan imza sahiplerine referans veriyor.',
    partialConfigMissingSigners: 'Yapılandırma kısmen yüklendi. Yüklemeyi tamamlamak için aşağıdaki imza sahiplerini ekleyin:\n{signerIds}',
    invalidElementDimensions: 'Uyarı: Yapılandırma, geçersiz boyutlara sahip (baş aşağı) {count} öğe içeriyor: {ids}. Bunlar otomatik olarak düzeltildi.',
    zeroSizedElements: 'Geçersiz yapılandırma: {count} öğe sıfır boyutlara sahip ve görüntülenemiyor.'
  }
};
